<template>
    <div class="orderManagementClass">
        <div class="orderManagementContent" :style="contentViewHeight">
            <div class="printOrderListBox">
                <div>
                    <div class="orderSearchBox">
                        <el-input v-model="circleName" placeholder="名称"></el-input>
                        <el-select v-model="status" placeholder="状态">
                            <el-option label="待审核" value="EXAMINE"> </el-option>
                            <el-option label="审核通过" value="PASS"> </el-option>
                            <el-option label="审核拒绝" value="REFUSE"> </el-option>
                        </el-select>
                        <el-button class="searchBtn" @click="search">搜索</el-button>
                        <el-button type="text" class="resetBtn" @click="resetData">
                            <i class="iconfont icon-qingchushujuku"></i>
                            <span>清除条件</span>
                        </el-button>
                    </div>
                    <div class="orderListTable">
                        <el-table
                            :data="tableData"
                            border
                            style="width: 100%" class="tableContent">
                            <el-table-column
                                prop="creatorName"
                                label="创建人"
                                header-align="center"
                                show-overflow-tooltip
                                width="100"
                                align="center">
                            </el-table-column>
                            <el-table-column
                                prop="fileUrl"
                                label="封面"
                                width="200"
                                header-align="center"
                                show-overflow-tooltip
                                align="center">
                                <template slot-scope="scope">
                                    <img v-if="scope.row.fileUrl !=null" :src="scope.row.fileUrl">
                                    <img v-else src="@/assets/images/defaultOrder.png">
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="circleName"
                                label="圈子名称"
                                header-align="center"
                                show-overflow-tooltip
                                width="200"
                                align="center">
                            </el-table-column>
                            <el-table-column
                                prop="content"
                                align="center"
                                header-align="center"
                                label="圈子内容" >
                                <template slot-scope="scope">
                                    <el-popover
                                        placement="top-start"
                                        width="500"
                                        trigger="hover"
                                        :content="scope.row.content">
                                        <span slot="reference" class="circleContent">{{scope.row.content}}</span>
                                    </el-popover>
                                </template>
                            </el-table-column>

                            <el-table-column
                                prop="modifyTime"
                                align="center"
                                header-align="center"
                                width="160"
                                label="提交时间">
                            </el-table-column>
                            <el-table-column
                                prop="statusCn"
                                align="center"
                                header-align="center"
                                width="80px"
                                label="状态">
                            </el-table-column>
                            <el-table-column
                                prop="addNum"
                                label="关注数量"
                                header-align="center"
                                width="80px"
                                align="center">
                            </el-table-column>
                            <el-table-column
                                prop="dynamicCount"
                                label="动态数量"
                                header-align="center"
                                width="80px"
                                align="center">
                            </el-table-column>
                            <el-table-column
                                label="操作"
                                header-align="center"
                                width="100"
                                align="center">
                                <template slot-scope="scope">
                                    <el-button type="text" size="small" v-if="scope.row.status=='EXAMINE'" @click="toDialog('1',scope.row.uuid)">审核</el-button>
                                    <el-button type="text" size="small" v-if="scope.row.status!='EXAMINE'" @click="toDialog('0',scope.row.uuid)">查看</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-pagination
                            background
                            @current-change="handleCurrentChange"
                            @prev-click="handleCurrentChange"
                            @next-click="handleCurrentChange"
                            layout="total,prev, pager, next,jumper"
                            :current-page="current"
                            :page-size="pageSize"
                            :total="total" class="pagination">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>

        <el-dialog
            :title="titleDialog"
            :visible.sync="dialogVisible"
            :close-on-click-modal="false"
            width="900px">
            <div class="examine" v-loading="loading">
                <div class="examineList examineListTwo">
                    <div class="examineListTwo_box">
                        <p style="white-space:nowrap">创建人:</p>
                        <p>{{ form.creatorName }}</p>
                    </div>
                    <div class="examineListTwo_box">
                        <p style="white-space:nowrap">圈子名称:</p>
                        <p>{{ form.circleName }}</p>
                    </div>
                </div>
                <div class="examineList examineListTwo">
                    <div class="examineListTwo_box">
                        <p style="white-space:nowrap">封面:</p>
                        <img :src="form.fileUrl" >
                    </div>
                </div>
                <div class="examineList examineListTwo">
                    <div class="examineListTwo_box">
                        <p style="white-space:nowrap">内容:</p>
                        <p>{{ form.content }}</p>
                    </div>
                </div>
                <div class="invoiceInformation" v-if="currentAudit == 0">
                    <h3>审核结果</h3>
                    <div class="examine">
                        <el-tag type="warning" effect="dark" v-if="form.status == 'EXAMINE'">审核中</el-tag>
                        <el-tag type="success" effect="dark" v-if="form.status == 'PASS'">审核已通过</el-tag>
                        <el-tag type="danger" effect="dark"  v-if="form.status == 'REFUSE'">审核已驳回</el-tag>
                        <div class="examineListTwo_box" v-if="form.status == 'REFUSE'">
                            <p>驳回原因：</p>
                            <p>{{ form.reason }}</p>
                        </div>
                    </div>
                </div>
                <div class="audit" v-if="currentAudit == 1">
                    <h3>审核</h3>
                    <div class="auditContent">
                        <el-radio-group v-model="form.status">
                            <el-radio label="PASS">通过</el-radio>
                            <el-radio label="REFUSE">拒绝</el-radio>
                        </el-radio-group>
                        <div class="cause" v-if="form.status === 'REFUSE'">
                            <div class="causeTitle">驳回原因：</div>
                            <div class="causeContent" style=" width: 100%;">
                                <el-input
                                    type="textarea"
                                    :autosize="{ minRows: 5}"
                                    placeholder="请输入驳回原因"
                                    v-model="form.reason">
                                </el-input>
                            </div>
                        </div>
                        <div class="auditEnter">
                            <el-button type="primary" @click="submit()">确定</el-button>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {
        circleQuery,
        getCircle,
        auditCircle
    } from '../../utils/interface';

    import uploadImage from '@/components/uploadImage'
    export default {
        components: {
            uploadImage,
        },
        data() {
            return {
                circleName:'',
                titleDialog:'',
                type: 'USER',
                status:'',
                tableData: [],
                current: 1,
                pageSize: 10,
                total: 0,
                form:{uuid:'',circleName:'',fileUrl:'',content:'',type: 'USER',},
                rules:{
                    circleName: [
                        {required: true, message: '请输入名称', trigger: 'blur'}
                    ],
                    content: [
                        {required: true, message: '请输入内容',trigger: 'blur'}
                    ],
                },
                loading:false,
                uuid:'',
                dialogVisible:false,
                currentAudit:0,
            }
        },
        computed: {
            contentViewHeight() {
                let height = document.documentElement.clientHeight - 120
                return {minHeight: height + 'px'}
            },
        },
        created() {
            this.getList();
        },
        methods: {
            getList(){
                let params = {
                    type: this.type,
                    circleName:this.circleName,
                    status:this.status,
                    current:this.current,
                    pageSize:this.pageSize,
                }
                circleQuery(params).then((res)=>{
                    this.tableData = res.data;
                    this.total = res.total;
                });
            },
            resetData(){
                this.circleName = '';
                this.status = '',
                this.current = 1;
                this.getList();
            },
            // 分页
            handleCurrentChange(val){
                this.current = val;
                this.getList();
            },
            search(){
                this.current = 1;
                this.getList();
            },
            init(){
                this.circleName = '';
                this.status = '',
                this.current = 1;
                this.getList()
            },
            // 编辑/新增
            toDialog(type,id){
                this.dialogVisible = true
                this.uuid = id;
                this.currentAudit = type;
                if (type === '0') {
                    this.titleDialog = '查看'
                    getCircle(id).then((item)=>{
                        this.form = item.data;
                    })
                } else {
                    this.titleDialog = '审核'
                    getCircle(id).then((item)=>{
                        this.form = item.data;
                        this.form.reason='';
                    })
                }
            },
            submit(){
                if(this.form.status=== undefined){
                    this.$message.warning('请选择审核结果！');
                } else if(this.form.status === 'REFUSE' && this.form.reason === null){
                    this.$message.warning('请输入驳回原因！');
                }else {
                    this.loading = true
                    auditCircle(this.form).then((res)=>{
                        if(res.success===true){
                            this.loading = false
                            this.$message.success('审核成功！')
                            this.dialogVisible = false;
                            this.getList();
                        }else{
                            this.loading = false
                            this.$message.error(res.message)
                        }
                    })
                }
            },
        }
    }
</script>

<style scoped lang="less">
    .orderManagementClass {
        position: relative;
        width: 100%;
        padding: 0 20px 20px;
        .orderManagementContent {
            background: #fff;
            .printOrderListBox {
                padding: 20px;
                .orderSearchBox {
                    display: flex;
                    flex-wrap: wrap;

                    /deep/ .el-input {
                        width: initial;
                        margin-bottom: 22px;
                        margin-right: 30px;
                    }

                    /deep/ .el-input__inner {
                        width: 242px;
                        height: 35px;
                        min-height: 35px;
                        font-size: 12px;
                        color: #999999;
                        background-color: #f2f4f7;
                        border: 1px solid #f2f4f7;
                        border-radius: 5px;

                        &:hover,
                        &:focus {
                            background-color: #fff;
                            border: 1px solid #108ee9;
                        }
                    }

                    /deep/ .el-input__prefix {
                        top: -3px;
                    }

                    /deep/ .el-input__suffix {
                        top: 2px;
                    }

                    /deep/ .el-button {
                        display: block;
                        line-height: 35px;
                        padding: 0;
                        height: 35px;
                    }

                    .searchBtn {
                        width: 82px;
                        background: #3d7fff;
                        border: none;
                        border-radius: 15px;
                        font-size: 14px;
                        color: #ffffff;
                    }

                    .resetBtn {
                        color: #333333;
                    }
                }

                .tableContent {
                    min-height: 650px;

                    /deep/ .el-table__header {
                        tr {
                            th {
                                border-right: none;
                            }
                        }

                        /deep/ .el-table__cell {
                            padding: 5px 0;
                            background: #f2f5fc;
                        }
                    }

                    /deep/ .el-table__body {
                        img {
                            vertical-align: middle;
                            width: 52px;
                            height: 50px;
                        }
                    }
                }

                .pagination {
                    margin-top: 20px;
                    text-align: right;
                }
            }
        }
        .tableTool {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            margin-bottom: 20px;
            .toolRight {
                button {
                    width: 83px;
                    height: 30px;
                    background: rgba(21, 126, 251, 1);
                    border: none;
                    border-radius: 15px;
                    font-size: 13px;
                    color: #fff;

                    i {
                        padding-right: 5px;
                    }

                    &:hover {
                        background: #61a2f0;
                    }
                }
            }
        }
        .dialogBox{
            .details{
                .detailsItem{
                    padding-bottom: 20px;
                    h3{
                        font-weight: 700;
                        font-size: 16px;
                        color: #000;
                        margin-top: 0;
                        letter-spacing: 1px;
                        border-bottom: 1px solid #ddd;
                        padding-bottom: 15px;
                    }
                    .itemContent{
                        display: flex;
                        flex-wrap: wrap;
                        font-size: 15px;
                        padding: 0 30px;
                        .one-row{
                            width: 50%;
                            margin-bottom: 22px;
                            display: flex;
                            .label{
                                padding-right: 15px;
                                min-width: 95px;
                            }
                            .name{
                                color: #000;
                            }
                        }
                        .two-row{
                            width: 100%;
                            margin-bottom: 22px;
                            display: flex;
                            .label{
                                padding-right: 15px;
                                min-width: 95px;
                            }
                            .name{
                                color: #000;
                            }
                        }
                    }
                    .itemPictureContent{
                        display: flex;
                        flex-wrap: wrap;
                        font-size: 15px;
                        padding: 0 30px;
                        justify-content: space-between;
                        .one-row{
                            width: 30%;
                            margin-bottom: 22px;
                            img{
                                width: 100%;
                                height: 138px;
                                border: 1px solid #ddd;
                            }
                            .name{
                                text-align: center;
                                padding-top: 10px;
                                font-size: 14px;
                                display: flex;
                                .label{
                                    min-width: 80px;
                                }
                            }
                        }
                    }
                }
            }

        }
    }
    .audit{
        padding-bottom: 20px;
        margin-top: 20px;
        h3{
            font-weight: 700;
            font-size: 16px;
            color: #000;
            margin-top: 0;
            letter-spacing: 1px;
            padding-bottom: 15px;
        }
        .cause{
            display: flex;
            margin-top: 20px;
            .causeTitle{
                min-width: 80px;
                color: #3a8ee6;
            }
            .causeContent{
                color: #000;
            }
        }
        .auditEnter{
            text-align: center;
            padding-top: 20px;
            button{
                width: 120px;
            }
        }
    }
    .examine {
        h2 {
            font-weight: 700;
            font-size: 16px;
            color: #000;
            margin-top: 26px;
            letter-spacing: 1px;
        }
        .examineList {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            img {
                width: 200px;
                height: 200px;
            }
            p:nth-of-type(1){
                margin-right: 16px;
                width: 65px;
                flex-shrink: 0;
            }
            .examine_html {
                width: 90%;
                /deep/pre {
                    white-space: pre-line !important;
                }
                /deep/img {
                    max-width: 100%;
                }
            }
            .examineListTwo_box{
                width: 50%;
            }
        }
        .examineListTwo {
            display: flex;
            align-items: center;
            .examineListTwo_box {
                display: flex;
                align-items: center;
                width: 50%;
            }
        }

    }
    .circleContent {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
</style>



// WEBPACK FOOTER //
// src/views/circle/circleAudit.vue